<template>
  <div class="profile-page">
    <div class="profile-content">
      <button class="back-button" @click="$emit('close-profile')">
        <i class="fas fa-arrow-left"></i>
      </button>

      <div class="profile-layout">
        <!-- Left side: Profile Card -->
        <div class="profile-card Frosted_glass">
          <p class="username-label">Sr. King</p>
          <div class="avatar-wrapper">
            <img src="@/assets/pfp.jpg" alt="Profile Image" class="profile-image">
          </div>
          <p class="hidden-info">More information yet to be unlocked</p>
        </div>

        <!-- Right side: About Me Card -->
        <div class="about-card Frosted_glass">
          <h2 class="section-title">About Me</h2>
          <div class="about-content">
            <p class="about-text">
              Hello, I'm a programming and ethical hacking prodigy who started at just 6 years old.
              Diagnosed with <span class="highlight-gold">autism</span> at an early age, I've always seen the world differently.
              I love to create and explore things, whether it's building software, exploiting systems, or crafting new ideas.
              When I'm not working, you'll find me playing video games, where I always play competitively.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  emits: ['close-profile']
}
</script>

<style scoped>
.profile-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transform: translateY(-100%);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.profile-page.slide-in {
  transform: translateY(0);
}

.profile-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 85%;
  max-width: 62rem;
  padding: 1rem;
}

.back-button {
  position: absolute;
  top: 2.3rem;
  right: 2.2rem;
  background: none;
  border: none;
  color: white;
  font-size: 1.65rem;
  cursor: none !important;
  padding: 0;
  line-height: 1;
  z-index: 1;
  transition: opacity 0.2s ease;
}

.back-button:hover {
  opacity: 0.65;
}

.profile-layout {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 2.5rem;
  width: 100%;
  padding-top: 0.5rem;
}

/* Left: Profile Card */
.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1.25rem;
  border-radius: 1rem;
  width: 14rem;
  flex-shrink: 0;
  gap: 1rem;
  backdrop-filter: blur(0.625rem) brightness(0.8);
}

.username-label {
  font-size: 1.75rem;
  font-weight: bold;
  margin: 0;
  text-align: center;
  letter-spacing: 0.0625rem;
}

.avatar-wrapper {
  width: 7.5rem;
  height: 7.5rem;
}

.profile-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
}

.hidden-info {
  font-size: 0.78rem;
  opacity: 0.4;
  font-style: italic;
  margin: 0;
  text-align: center;
  letter-spacing: 0.03125rem;
}

/* Right: About Me Card */
.about-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 2rem;
  border-radius: 1rem;
}

.section-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 1.5rem 0;
  letter-spacing: 0.0625rem;
}

.about-content {
  text-align: center;
}

.about-text {
  font-size: 1.05rem;
  opacity: 0.85;
  margin: 0;
  line-height: 1.9;
  max-width: 38rem;
}

.Frosted_glass {
  backdrop-filter: blur(0.625rem) brightness(0.7);
}

/* Highlight styles */
.highlight-gold {
  color: #e2b96f;
  font-weight: 600;
}

.highlight-bold {
  font-weight: 700;
}

.highlight-italic {
  font-style: italic;
  opacity: 0.95;
}

@media (max-width: 768px) {
  .profile-content {
    width: 92%;
  }

  .profile-layout {
    flex-direction: column;
    gap: 1.5rem;
  }

  .profile-card {
    flex-direction: row;
    padding: 1rem 1.25rem;
    gap: 1rem;
    width: auto;
    flex-wrap: wrap;
    justify-content: center;
  }

    .username-label {
      font-size: 1.35rem;
    }

    .avatar-wrapper {
      width: 5rem;
      height: 5rem;
    }

    .hidden-info {
      width: 100%;
      font-size: 0.7rem;
    }

  .section-title {
    font-size: 1.5rem;
  }

  .about-text {
    font-size: 0.95rem;
  }
}
</style>
